import type { AppConfig } from '../../src/utils/baseConfig';

export const config: Partial<AppConfig> = {
  // Empty - uses all defaults
};